import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {

  title = 'JAX Image Tools';
  titleSuffix = environment.titleSuffix;
  user$ = this.auth.user$;

  showDialog = false;

  constructor(
    public auth: AuthService,
    @Inject(DOCUMENT) public document: Document
  ) { }


  login() {
    this.auth.loginWithRedirect();
  }

  logout() {
    this.auth.logout({
      logoutParams: {
        returnTo: document.location.origin
      }
    });
  }

}
